import {styled, Button, InputLabel, Stack} from '@mui/material'

export const CancelBtn = styled(Button)(({theme}) => ({
  minWidth: '8rem',
  backgroundColor: theme.palette.error.light,
}))

export const ButtonsWrapper = styled(Stack)(() => ({
  gap: '1.5rem',
  flexDirection: 'row',
  justifyContent: 'flex-end',
}))

export const Label = styled(InputLabel)(({theme}) => ({
  textAlign: 'start',
  color: theme.palette.grey[100],
  ...theme.typography.body2,
}))

export const pdfViewStyle = {border: 'none'}
